import "@/helpers/turbo"
import "@/styles/home_v2.scss"

import { application } from "@/helpers/stimulus"

import { initHomeSearch } from "@/components/elm_search"
import { setupSearchBar } from "@/components/search_bar"

import CarouselController from "../controllers/carousel_controller"
import TabsController from "../controllers/tabs_controller"

const setupStimulus = (): void => {
  application.register("carousel", CarouselController)
  application.register("tabs", TabsController)
}

const NEW_SEARCH_BAR = document.body.getAttribute("data-new-search-bar") === "true"

if (NEW_SEARCH_BAR) {
  setupSearchBar()
} else {
  initHomeSearch()
}

setupStimulus()
